/* testDataThunk.ts */

/* Redux Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppDispatch } from "src/redux/store";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Thunks */
import { syncMainCondition } from "src/redux/thunks/insights-filter/main-condition/syncMainConditionThunk";

/* Utils */
import { transformTestData } from "src/utils/helper/test-data/transformTestData";

/* Interfaces */
import { TestDataProps } from "src/shared/interfaces/common/TestData";

export const fetchTestData = createAsyncThunk(
  "fetchTestData",
  async () => {
    try {
      const response = await axiosInterceptor.get(
        "/test_data"
      );
      const { data } = response.data;
      return transformTestData(data);
    } catch (error) {
      console.error(error);
    }
  }
);

export const importTestData = createAsyncThunk<
  TestDataProps,
  TestDataProps,
  {
    dispatch: AppDispatch;
  }
>(
  "importTestData",
  async (params: TestDataProps, { dispatch }) => {
    try {
      const { foldername, name } = params;
      const response = await axiosInterceptor.post(
        "/test_data/import",
        {
          foldername,
          name,
        }
      );

      await dispatch(syncMainCondition({ flush: true }));

      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteTestData = createAsyncThunk<
  TestDataProps,
  TestDataProps,
  {
    dispatch: AppDispatch;
  }
>(
  "deleteTestData",
  async (params: TestDataProps, { dispatch }) => {
    try {
      const { foldername, name } = params;

      const response = await axiosInterceptor.post(
        "/test_data/delete",
        {
          foldername,
          name,
        }
      );
      await dispatch(syncMainCondition({ flush: true }));
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
);
